import { Link, useRouterState } from '@tanstack/react-router'
import type { Capability } from '@one-deployment/shared'
import { useCan } from '@/components/RoleGate'
import { cn } from '@/lib/cn'

const TABS: Array<{ to: string; label: string; cap?: Capability }> = [
  { to: '/settings/usage', label: 'Usage' },
  { to: '/settings/claude-accounts', label: 'Claude accounts' },
  { to: '/settings/connections', label: 'Connections', cap: 'integrations.manage' },
  { to: '/settings/backups', label: 'Backups', cap: 'backups.restore' },
  { to: '/settings/people', label: 'People', cap: 'people.invite' },
]

function Tab({ to, label, cap }: (typeof TABS)[number]) {
  const path = useRouterState({ select: (s) => s.location.pathname })
  const allowed = useCan(cap ?? 'project.read')
  if (cap && !allowed) return null
  const active = path.startsWith(to)
  return (
    <Link to={to} className={cn('h-7 rounded-md px-2.5 text-sm leading-7 transition-colors', active ? 'bg-surface-3 text-fg' : 'text-fg-subtle hover:bg-hover hover:text-fg')}>{label}</Link>
  )
}

/** Settings is one page with a tab per area; each tab is its own route. */
export function withSettingsTabs(Page: () => React.ReactNode) {
  return function SettingsPage() {
    return (
      <div>
        <div className="flex h-11 items-center gap-1 px-6">{TABS.map((t) => <Tab key={t.to} {...t} />)}</div>
        <Page />
      </div>
    )
  }
}
